var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "e-invoicing-button" }, [
    _c(
      "button",
      {
        staticClass:
          "e-invoicing-button__button typographies-paragraph-small-semibold",
        on: {
          click: function($event) {
            return _vm.$emit("click")
          }
        }
      },
      [
        _c("SassIcon", {
          attrs: { icon: "EInvoicing", height: 16, width: 16 }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "e-invoicing-button__label" }, [
          _vm._v(_vm._s(_vm.$t.__("common.labels.einvoicing")))
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }